import React, { Fragment, useEffect, useState } from 'react';
import '../resources/css/block_ClubLeaderBoard.css';
import { useParams, Link } from 'react-router-dom'

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps } from '../../../../Brands/SSD/Start';
//import { CompsAPI } from '../Shared/DataCompAPI';
import CompsAPI from '../Shared/DataCompAPI';
import Common from '../../../../Shared/Common';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faTable, faImage, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from 'reactstrap';
import ConfirmWindow from '../../../Digital/ConfirmWindow';

export const Comps_ClubLeaderBoard = (props) => {
    let { view } = useParams();

    return (
        <SSDComps>
            <Comps_ClubLeaderBoardContent view={view} />
        </SSDComps>
    );
}   
export default Comps_ClubLeaderBoard;

export const Comps_ClubLeaderBoardContent = (props) => {

    const [blockName, setBlockName] = useState("");

    const [adminModel, setadminModel] = useState(props.view);
    const [year, setYear] = useState("2026");
    const [puckoEntries, setPuckoEntries] = useState([]);
    const [speciesEntries, setSpeciesEntries] = useState([]);

    const [open, setOpen] = useState(false);
    const [selectedEntry, setselectedEntry] = useState([]);
    const [viewMode, setViewMode] = useState("TableView");
    const [confirmDelete, setConfirmDelete] = useState(false);
    
    useEffect(() => {
        CompsAPI.getPucko({}, puckoCallback);
        CompsAPI.getSpecies({}, speciesCallback);
    }, []);

    let puckoCallback = (data) => {
        setPuckoEntries(data);
    };

    let speciesCallback = (data) => {
        setSpeciesEntries(data);
    };


    const toggle = () => {
        setOpen(!open);
    };

    const openPopUp = (entry) => {
        Common.log("open Entry pop up");
        Common.log(entry);

        setOpen(!open);
        setselectedEntry(entry);
    };

    const closePopUp = () => {
        setOpen(false);
    };

    const toggleView = () => {
        if (viewMode == "CardView")
            setViewMode("TableView");
       
        if (viewMode == "TableView")
            setViewMode("CardView");
    };

    const remove = (entry) => {
        setselectedEntry(entry);
        setConfirmDelete(true);
    };

    const onConfirmShow = () => {
        setConfirmDelete(!confirmDelete);
    };

    const onConfirmDeleteYes = (event) => {
        setConfirmDelete(false);
    };

    const onConfirmDeleteNo = (event) => {
        setConfirmDelete(false);
    };

    return (
        <Block name="Records" isAlt={false}>
            <TextHeader 
                text={"Sanc Souci Dolphins Competition Leaderboard"}
            />

            <Row>
                <Col lg="8">
                    <span>
                        This year's results for the Club Competitions!!! - <Link to="/Competitions/SubmitClubRecord">Make your Submission here</Link>
                    </span>
                </Col>

                <Col lg="4" className="text-right">
                    <Button color="success" onClick={toggleView}> <FontAwesomeIcon icon={faImage} />&nbsp;Card View</Button> &nbsp;
                    <Button color="primary" onClick={toggleView}> <FontAwesomeIcon icon={faTable} />&nbsp;Table View</Button>
                </Col>
            </Row>

            <Row>
                <Col lg="12" className="text-left">
                    <h1>Pucko Challenge</h1>
                </Col>
            </Row>

            {(viewMode == "CardView") &&

                <Row>
                    {puckoEntries.map((entry, index) =>
                        <Col lg="4" className="" key={index} className="text-center" >

                            <div className="projectPopUp">
                                <a onClick={openPopUp.bind(this, entry)}>
                                    <div className="projectPopUp-img">
                                        <img width="282"
                                            src={entry.fishPhotoUrl}
                                            sizes="(max-width: 322px) calc(100vw - 40px), 282px" />
                                    </div>

                                    <div className="projectPopUp-img-effect">
                                        <div className="projectPopUp-img-effect-desc">
                                            <div className="project-cat">{entry.diver}</div>
                                            <div className="project-desc">{entry.fishPelagic} - { entry.weight } - {entry.caught}</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div>
                                <b>{entry.fishPelagic} - {entry.weight}</b>
                            </div>
                        </Col>
                    )}
                </Row>
            }


            {(viewMode == "TableView") &&
                <Row>
                    <Col>
                        <Table striped hover borderless>
                            <thead>
                                <tr>
                                    <th>
                                        Position #
                                    </th>
                                    <th>
                                        Diver
                                    </th>
                                    <th>
                                        Fish
                                    </th>
                                    <th>
                                        Weight
                                    </th>
                                    <th>
                                        Length
                                    </th>
                                    <th>
                                        Caught
                                    </th>
                                    <th>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {puckoEntries.map((entry, entryIndex) =>
                                    <tr key={entryIndex}>
                                        <td>
                                            <span>{entryIndex + 1}</span>
                                        </td>
                                        <td>
                                            <span>{entry.diver}</span>
                                        </td>
                                        <td>
                                            <span>{entry.fishPelagic}</span>
                                        </td>
                                        <td>
                                            <span>{entry.weight}</span>
                                        </td>
                                        <td>
                                            <span>{entry.length}</span>
                                        </td>
                                        <td>
                                            <span>{entry.caught}</span>
                                        </td>
                                        <td>
                                            <a className="btn btn-success" onClick={openPopUp.bind(this, entry)}><FontAwesomeIcon icon={faImage} /> Photo</a>
                                            {(adminModel== "isAdmin") &&
                                                <Fragment>
                                                    &nbsp;<a className="btn btn-danger" onClick={remove.bind(this,entry)}><FontAwesomeIcon icon={faTrash} /> Delete</a>
                                                </Fragment>
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            }

            <Row>
                <Col lg="12" className="text-left">
                    <h1>Club Species Challenge</h1>
                </Col>
            </Row>

            {(viewMode == "CardView") &&

                <Row>
                    {speciesEntries.map((entry, index) =>
                        <Fragment>
                            {!entry.isEmptyRow &&
                                <Col lg="4" className="" key={index} className="text-center" >

                                    <div className="projectPopUp">
                                        <a onClick={openPopUp.bind(this, entry)}>
                                            <div className="projectPopUp-img">
                                                <img width="282"
                                                    src={entry.fishPhotoUrl}
                                                    sizes="(max-width: 322px) calc(100vw - 40px), 282px" />
                                            </div>

                                            <div className="projectPopUp-img-effect">
                                                <div className="projectPopUp-img-effect-desc">
                                                    <div className="project-cat">{entry.diver}</div>
                                                    <div className="project-desc">{entry.fishSpecies} - {entry.weight} - {entry.caught}</div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div>
                                        <b>{entry.fishPelagic} - {entry.weight}</b>
                                    </div>
                                </Col>
                            }
                            </Fragment>
                    )}
                </Row>
            }

            {(viewMode == "TableView") &&

                <Row>
                    <Col>
                        <Table hover borderless >
                            <thead>
                                <tr>
                                    <th>
                                        Species
                                    </th>
                                    <th>
                                        Diver
                                    </th>
                                    <th>
                                        Weight
                                    </th>
                                    <th>
                                        Length
                                    </th>
                                    <th>
                                        Caught
                                    </th>
                                    <th>
                                        Photos
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {speciesEntries.map((entry, entryIndex) =>
                                    <tr key={entryIndex}>
                                        <td>
                                            <span>{entry.fishSpecies}</span>
                                        </td>
                                        <td>
                                            <span>{entry.diver}</span>
                                        </td>
                                        <td>
                                            <span>{entry.weight}</span>
                                        </td>
                                        <td>
                                            <span>{entry.length}</span>
                                        </td>
                                        <td>
                                            <span>{entry.caught}</span>
                                        </td>
                                        <td>
                                            {!entry.isEmptyRow &&
                                                <Fragment>
                                                    <a className="btn btn-success" onClick={openPopUp.bind(this, entry)}><FontAwesomeIcon icon={faImage} /> Photo</a>
                                                    {(adminModel == "isAdmin") &&
                                                        <Fragment>
                                                            &nbsp;<a className="btn btn-danger" onClick={remove.bind(entry)}><FontAwesomeIcon icon={faTrash} /> Delete</a>
                                                        </Fragment>
                                                    }
                                                </Fragment>
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            }

            <Row>
                <Col>
                    <div>
                        <Modal isOpen={open} toggle={toggle} className="modal-project" centered size="lg">

                            <ModalBody>
                                <Container>
                                    <Row>
                                        <Col lg="6" className="modal-col modal-project-img align-self-center">
                                            <img className="img-fluid" src={selectedEntry.fishPhotoUrl} />
                                            {(adminModel == "isAdmin") &&
                                                <img className="img-fluid" src={selectedEntry.weightPhotoUrl} />
                                            }
                                        </Col>

                                        <Col lg="6" className="modal-col">
                                            <div className="modal-project-cat">
                                                {selectedEntry.CompName}
                                                <span className="modal-close-button float-right" onClick={closePopUp}><FontAwesomeIcon icon={faWindowClose}> </FontAwesomeIcon></span>
                                            </div>
                                            <div className="modal-project-info">
                                                <span className="modal-project-cat"> Species - </span>{selectedEntry.fishPelagic}
                                            </div>
                                            <div className="modal-project-desc">
                                                <span className="modal-project-cat"> Length - </span>{selectedEntry.length}
                                            </div>
                                            <div className="modal-project-desc">
                                                <span className="modal-project-cat"> Weight - </span>{selectedEntry.weight}
                                            </div>
                                            <div className="modal-project-desc">
                                                <span className="modal-project-cat"> Caught on - </span>{selectedEntry.caught}
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </ModalBody>
                        </Modal>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    {confirmDelete &&
                        <ConfirmWindow
                            header="Confirm Action"
                            message="Do you wish to delete the record?"
                            onShowAction={onConfirmShow}
                            onYesAction={onConfirmDeleteYes}
                            onNoAction={onConfirmDeleteNo}
                        />
                    }
                </Col>
            </Row>
        </Block>
    );
}
